import { render } from "./FormTextRow.vue?vue&type=template&id=15680188"
import script from "./FormTextRow.vue?vue&type=script&lang=js"
export * from "./FormTextRow.vue?vue&type=script&lang=js"

import "./FormTextRow.vue?vue&type=style&index=0&id=15680188&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__